/*
 * Nav surface discriminator (design-uplift R2 measurement seam).
 *
 * The desktop icon-rail and the bottom tab bar both route through MenuView's
 * single onMenuSelect handler, which emits one "Menu-<route>" mixpanel event per
 * destination. Without this property the two navs are indistinguishable in the
 * data, so a post-flip reading can show THAT a destination lost traffic but never
 * WHY — and the R2 rebuild moves Subscriptions and Share & Earn off a persistent
 * rail into the More overflow, which is precisely the case that needs diagnosing.
 *
 * Deliberately its own module rather than a new export on navFlags.js: several
 * suites jest.mock navFlags wholesale (`() => ({ NAV_BOTTOM_TABS: true })`), and
 * an added export there would read as undefined inside them.
 *
 * Values are stable wire strings — they land in mixpanel as the `navSurface`
 * property. Do not rename without migrating the saved reports.
 */
export const NAV_SURFACE = Object.freeze({
  // Legacy desktop icon-rail (flag OFF, and the pre-flip baseline).
  RAIL: 'rail',
  // A primary tab on the bottom tab bar: Practice / Progress / Account.
  TAB: 'tab',
  // A row inside the More overflow sheet.
  MORE_SHEET: 'more-sheet',
  /*
   * NOT a navigation. `Menu-create-quiz` has two shadow emitters that fire on
   * sign-in and session restore (login.jsx, create-quiz-page.jsx) — and they
   * land on the destination event of the Practice tab, the highest-volume tab
   * there is. Left unstamped they form a large `(not set)` bucket made of LOGIN
   * volume: proportional to DAU and flat across the flip, it would drown the
   * tab-vs-overflow signal on the flagship tab and make Practice read "no
   * change" whatever the tab bar actually did. The bucket is biased too — email
   * login emits it, phone-OTP login does not.
   *
   * So they are labelled rather than left absent. EXCLUDE this value when
   * reading nav behaviour; it marks a session start, not a tap.
   */
  AUTH_REDIRECT: 'auth-redirect',
});

// Emitted when the More sheet is opened, independent of whether a destination is
// then chosen. Opens-without-a-selection are the signal that something students
// want is buried — the counterpart to the navSurface property on the destination
// events.
export const MORE_SHEET_OPENED_EVENT = 'Menu-more-sheet-opened';
